module.exports = __webpack_public_path__ + "img/haut-und-haarpflege_hauptseite_HINTERGRUND.d5260e03.jpg";